import { useNavigate } from "react-router-dom"

export const PageNotFound = () => {
    const navigate = useNavigate()
    return (
        <div className="flex min-h-screen items-center justify-center bg-figmaLightBg px-4">
            <div className="text-center">
                <h1 className="text-[48px] sm:text-[64px] font-bold text-figmaPrimary">
                    404
                </h1>

                <h2 className="mt-4 text-[20px] sm:text-[24px] text-figmaBlack font-semibold">
                    Pagina nu a fost găsită
                </h2>

                <p className="mt-2 text-figmaDarkGray text-[14px] sm:text-[16px]">
                    Pagina pe care o căutați nu există sau a fost mutată.
                </p>

                <button
                    onClick={() => navigate("/home")}
                    className="mt-6 rounded-[12px] bg-figmaPrimary px-6 py-3 text-figmaWhite font-semibold transition hover:opacity-90"
                >
                    Înapoi acasă
                </button>
            </div>
        </div>
    )
}